<template>
  <div class="page-main">
    <div class="app-appbar">
      <nav-bar
        title="请选择城市"
      />
      <div class="page-form">
        <input v-model="query" placeholder="请输入搜索的城市" />
      </div>
    </div>

    <div class="page-center">

    <index-bar highlight-color="#00af66">
      <template v-for="(type,index) in getCityList.type" >
        <div :key="index">
          <index-anchor :index="type"/>
          <!-- 列表 -->
          <ul class="city-list">
            <li
              class="city-item"
              v-for="city in getCityList['list'][type]"
              :key="city.citycode"
              @click="toShop(city)"
            >
              {{ city.city }}
            </li>
          </ul>
          <!-- 列表 -->
        </div>
      </template>
    </index-bar>
    </div>
  </div>
</template>

<script>
import { getCity } from "@/api";
import { NavBar,IndexBar, IndexAnchor} from 'vant';


export default {
  data() {
    return {
      query: "",
      cityList: {},
    };
  },
  methods: {
    toShop(d) {
      this.$store.commit("setCity", d);
      this.$router.replace({ name: "shop" });
    },
  },
  computed: {
    getCityList() {
      var list = this.cityList;

      if (this.query) {
        list = {};
        for (var key in this.cityList) {
          var _list = this.cityList[key].filter((d) => {
            if (
              d.city.indexOf(this.query) != -1 ||
              d.cityEn.toUpperCase().indexOf(this.query.toUpperCase()) != -1
            ) {
              return true;
            } else {
              return false;
            }
          });

          if (_list.length > 0) {
            list[key] = _list;
          }
        }
      }

      return {
        type: Object.keys(list).sort(),
        list: list,
      };
    },
  },
  created() {
    getCity().then((d) => {
      this.cityList = d.data;
    });
  },
  components:{
    NavBar,IndexBar, IndexAnchor
  }
};
</script>

<style lang="scss" scoped>
.page-main{
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;

  .app-appbar{
    position: static;
    left: 0 !important;
    margin: 0 !important;
  }
}

.page-center{
  flex: 1;
  overflow: scroll;

  ::v-deep .van-index-anchor{
    background: #f1f1f1 !important;
  }

  .city-list{
    
    .city-item{
      padding: 20px 30px;
      position: relative;

      &:not(:last-child){
        border-bottom: 1px solid #f1f1f1;
      }
    }
  }
}

.page-form{
  height: 100px;
  padding: 20px 30px;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;

  input{
    width: 100%;
    height: 100%;
    padding: 0 0.4rem;
    border: none;
    background: #f1f1f1;
    box-sizing: border-box;
    border-radius: 0.5rem;
  }
}
</style>